import axios from "axios";
import Config from "src/config";

const v2_actionCaledarioDetalhes = (id) => {
    return axios({
        method: "get",
        url: `${Config.dev ? Config.url_dev : Config.urlBackend}/api/v2/calendarios/${id}`
    });
};
export default v2_actionCaledarioDetalhes;
